export default __webpack_public_path__ + "static/mitsubishi-d08951d1c9e371640b96acd5656f3f24.jpg";